// Pure helper for reading a persisted Bullhorn embed session context and
// rebuilding its re-entry URL. Lives in repo-root shared so it can be used
// by both the references project (EmbedSessionService) and the global HTTP
// interceptor without either one depending on the other's project.

interface IEmbedContext {
  atsKey: string;
  embedToken: string;
  entityId: string;
  entityType: string;
  userId: string;
  corporationId: string;
  // 'list' re-enters onto /embed/:atsKey/list; anything else (including the card, whose
  // compact frame deliberately re-enters onto the full tab) uses the tab route.
  surface?: 'tab' | 'card' | 'list';
}

export const CONTEXT_KEY = 'references.vitay.io.embedContext';

export function embedReenterUrl(): string | null {
  const raw = sessionStorage.getItem(CONTEXT_KEY);
  if (!raw) { return null; }

  try {
    const context = JSON.parse(raw) as IEmbedContext;
    const query = new URLSearchParams({
      et: context.embedToken,
      EntityID: context.entityId,
      EntityType: context.entityType,
      UserID: context.userId,
      CorporationID: context.corporationId
    });
    const path = context.surface === 'list' ? `/embed/${context.atsKey}/list` : `/embed/${context.atsKey}`;
    return `${path}?${query.toString()}`;
  } catch {
    // Malformed/corrupt sessionStorage value: treat exactly like "no context"
    // so callers (e.g. the 401 interceptor) fall back to their normal path
    // instead of throwing mid-catchError.
    return null;
  }
}
